import { useMutation } from '@tanstack/react-query';
import api from '@api/http/api';

export function useCollectQuestMutation() {
  return useMutation<{ success: true }, { error: string }, { id: string }>({
    mutationFn: (values) => api.post('/quests/collect', values),
  });
}
